import React, { FC } from 'react';
import 'whatwg-fetch';
import { LegacyUser } from 'src/interfaces/api/User';
import { LegacyEmployee } from 'src/interfaces/api/Employee';
import { Container, Grid } from '@material-ui/core';
import HeaderCard from './components/HeaderCard';
import AboutCard from './components/AboutCard';
import SettingButton from './components/SettingButton';
import { createUseStyles } from 'src/theming';
import Feed from './components/Feed';

const useStyles = createUseStyles({
  root: {
    marginTop: 80,
  },
  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

interface Props {
  user?: LegacyUser & {
    newCrmId?: string;
    typeUser: Omit<LegacyEmployee, 'user'>;
  };
  isMe?: boolean;
  loading?: boolean;
  error?: string;
}

const Profile: FC<Props> = ({ user, isMe, loading, error }) => {
  const classes = useStyles();

  return (
    <Container maxWidth='lg' className={classes.root}>
      <Grid container spacing={4}>
        {isMe && user?.enabled && (
          <Grid item xs={12} className={classes.flexEnd}>
            <SettingButton />
          </Grid>
        )}

        <Grid item xs={12}>
          <HeaderCard user={user} loading={loading} />
        </Grid>

        {!loading && !error && user && (
          <>
            <Grid item xs={12} sm={4}>
              <AboutCard user={user} />
            </Grid>

            <Grid item xs={12} sm={8}>
              <Feed employeeId={user.newCrmId} />
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
};

export default Profile;
